export default "__VITE_ASSET__cbbAF1D2__"